import React from 'react';
import SignInLayoutV1 from './SignInLayoutV1';
import { SignInLayoutV2 } from './SignInLayoutV2';
import SecondScreen from './SecondScreen';

export const SignInLayout = (props) => {
  const { isGifting, isDeviceActivation, defaultConfig } = props;

  if (isDeviceActivation) {
    return <SecondScreen {...props} />;
  }
  return defaultConfig.mvpdSignIn && !isGifting ? <SignInLayoutV2 {...props} /> : <SignInLayoutV1 {...props} />;
};
